import type { CardContextTabsProps } from "./card-context-tabs.type";

import { Card } from "antd";
import classNames from "classnames";
import { useEffect } from "react";
import { useSearchParams } from "react-router";

import { TAB_PARAM_KEYS } from "@/constants/TabKeys";

import "./card-context-tabs.style.less";

/**
 * @deprecated - use `TabView` instead
 */
export const CardContextTabs = ({
  tabs,
  defaultActiveKey,
  title,
  description,
  className,
  isScrollable = false,
  tabKey = TAB_PARAM_KEYS.CONTEXT_TAB_KEY,
  children,
  ...cardProps
}: CardContextTabsProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const getTabUrlParam = () => searchParams.get(tabKey)?.toLowerCase();

  const currentTabKey = getTabUrlParam() ?? defaultActiveKey;
  const selectedTab = tabs?.find((t) => t.key === currentTabKey && !t.disabled);

  const onTabChange = (key: string) => {
    setSearchParams((params) => {
      params.set(tabKey, key.toLowerCase());
      return params;
    });
  };

  useEffect(() => {
    // If selected tab does not exist and tab param exists in url,
    // reset tab param url value to make sure existing default tab
    // will be displayed instead of ghost tab
    if (!selectedTab && getTabUrlParam()) {
      setSearchParams(
        (params) => {
          params.delete(tabKey);
          return params;
        },
        { replace: true }
      );
    }
  }, [selectedTab]);

  return (
    <Card
      activeTabKey={currentTabKey}
      onTabChange={onTabChange}
      tabList={tabs}
      title={
        <>
          {title} {description && <span>- {description}</span>}
        </>
      }
      {...cardProps}
      classNames={{
        root: classNames("card-context-tabs", className, {
          "card-context-tabs-scrollable": isScrollable,
        }),
        header: "card-context-tabs--header",
        body: "card-context-tabs--body",
        actions: "card-context-tabs--actions",
      }}
    >
      <>
        {children}
        {selectedTab?.render?.()}
      </>
    </Card>
  );
};
